export function getObjectKeyByValue(obj: Object, value: string) {
  return Object.entries(obj).find(([key, val]) => val === value)?.[0];
}